// src/components/programs/ProgramForm/Step1Sections/ProductsPanel/ProductsPagination.jsx

import React from "react";
import { Pagination, Stack, Typography } from "@mui/material";

const ProductsPagination = ({
    currentPage,
    totalPages,
    onPageChange,
    isArabic,
}) => {
    return (
        <Stack spacing={1} alignItems="center">
            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(e, value) => onPageChange(value)}
                size="small"
                color="primary"
                showFirstButton
                showLastButton
                // ✅ التعديل هنا: تدوير الأيقونات 180 درجة إذا كانت اللغة عربية
                sx={{
                    '& .MuiPaginationItem-icon': {
                        transform: isArabic ? 'rotate(180deg)' : 'none',
                    },
                }}
            />
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                {isArabic
                    ? `صفحة ${currentPage} من ${totalPages}`
                    : `Page ${currentPage} of ${totalPages}`}
            </Typography>
        </Stack>
    );
};

export default ProductsPagination;